import { useCallback } from "react";

import { useMutation, UseMutationResult } from "@tanstack/react-query";
import { KB_SOURCE } from "util/constants";

import axios from "@/configs/axios";
import { DownloadBlobInformation } from "@/generated-types";

export const usePostPreviewBlobs = (): UseMutationResult<
  Blob,
  Error,
  DownloadBlobInformation,
  unknown
> => {
  const fetchBlobs = useCallback(async (payload: DownloadBlobInformation): Promise<Blob> => {
    const url = `${process.env.REACT_APP_SERVER_HOST}/preview/?source=${KB_SOURCE}`;
    const response = await axios.post(url, payload, {
      responseType: "blob", // To receive binary data
      headers: {
        "Cache-Control": "no-store",
      },
    });

    return response.data;
  }, []);
  return useMutation<Blob, Error, DownloadBlobInformation, unknown>({
    mutationFn: fetchBlobs,
  });
};
